import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AnchorService {
  http = inject(HttpClient);

  constructor() {}

  createApiKey(service: string): Promise<any> {
    return firstValueFrom(
      this.http.post(`${environment.apiUrl}/company/api-key`, { service }),
    );
  }

  getAnchorApiKey(): Promise<any> {
    return firstValueFrom(
      this.http.get(`${environment.apiUrl}/company/api-key`),
    );
  }

  deleteApiKey(uuid): Promise<any> {
    return firstValueFrom(
      this.http.delete(`${environment.apiUrl}/company/api-key/${uuid}`),
    );
  }
}
